import React, { useEffect, useState } from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import InputText from "../ui/InputText";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import Datepicker from "react-tailwindcss-datepicker";
import { MdAutorenew } from "react-icons/md";
import FormLoader from "../ui/FormLoader";

const RenovarCotiDialog = ({
  open,
  onClose,
  serviciosList,
  pagoList,
  cotizacionesList,
  setCotizacionesList,
  data,
}) => {
  const [formValues, setFormValues] = useState({
    numeroRenovacion: 1,
    fechaCotizacionLimite: {
      startDate: null,
      endDate: null,
    },
  });

  const [loading, setLoading] = useState(false);

  const renewCot = async () => {
    if (!formValues.fechaCotizacionLimite.startDate) {
      toast.warning("Elige una fecha limite", {
        style: { zIndex: 99999 },
        position: "top-center",
      });
      return;
    }
    setLoading(true);

    try {
      const responseNewCot = await axios.post(`${BACKEND}/api/cotizaciones`, {
        cliente: data.cliente.id,
        cotizador: data.cotizador.id,
        fuenteLead: data.fuenteLead,
        numeroCotizacion: data.numeroCotizacion,
        fechaCotizacionLimite: formValues.fechaCotizacionLimite.startDate,
        tipo: "Factura",
        estado: "En espera",
        moneda: data.moneda,
        totalPagado: data?.totalPagado ? data?.totalPagado : 0,
        precioTotal: data?.precioTotal ? data?.precioTotal : 0,
        numeroRenovacion: formValues.numeroRenovacion,
        fuenteVentas: "Agencia",
      });

      const cotId = responseNewCot.data.doc.id;
      setCotizacionesList([responseNewCot.data.doc, ...cotizacionesList]);

      await Promise.all([postAllPagos(cotId), postAllServices(cotId)]);

      await onClose();
      toast.success("Cotizacion renovada", {
        style: { zIndex: 9999 },
        position: "top-center",
      });
    } catch (error) {
      toast.error("Error al renovar cotizacion", {
        style: { zIndex: 9999 },
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  const postAllServices = async (idCotizacion) => {
    for (const service of serviciosList) {
      try {
        // Assuming you have a specific endpoint for your POST request

        let responseServicios = await axios.get(
          `${BACKEND}/api/serviciosCotizaciones?where[cotizacion.cliente][equals]=${data.cliente.id}&where[estado][equals]=Terminado con exito&where[servicio][equals]=${service.servicio.id}`
        );
        const response = await axios.post(
          `${BACKEND}/api/serviciosCotizaciones`,
          {
            cotizacion: idCotizacion,
            estado: "Por comenzar",
            numeroRenovacion: responseServicios.data.docs.length,
            responsable: service.responsable.id,
            subarea: service.subarea,
            codigo: service?.codigo ? service?.codigo : serviciosList.id,
            servicio: service.servicio.id,
            planServicio: service.planServicio.id,
            numeroItems: service.numeroItems,
            igv: service?.idv ? service?.igv : "no",
            fechaInicio: service.fechaInicio,
            fechaFin: service.fechaFin,
          }
        );

        // Create satisfaction form  by defaulty
        const servicioFormSatisfaccion = await axios.get(
          `${BACKEND}/api/formularioServicio?where[servicio][equals]=${service?.id}&where[tipo][equals]=satisfaccion&depth=0`
        );

        const servicioFormEntrada = await axios.get(
          `${BACKEND}/api/formularioServicio?where[servicio][equals]=${service?.id}&where[tipo][equals]=entrada&depth=0`
        );

        if (servicioFormSatisfaccion?.data?.docs.length > 0) {
          await axios.post(`${BACKEND}/api/formularioServicioRespuestas`, {
            servicioCotizacion: service?.id,
            formulario: servicioFormSatisfaccion.data.docs[0].id,
          });
        }

        if (responseServicios.data.docs.length === 0) {
          if (servicioFormSatisfaccion?.data?.docs.length > 0) {
            await axios.post(`${BACKEND}/api/formularioServicioRespuestas`, {
              servicioCotizacion: service?.id,
              formulario: servicioFormEntrada.data.docs[0].id,
            });
          }
        }
        //

        const responseEtapa1 = await axios.post(
          `${BACKEND}/api/etapasServiciosCotizaciones`,
          {
            servicio: response.data.doc.id,
            name: "Etapa 1",
          }
        );

        const responseEtapa2 = await axios.post(
          `${BACKEND}/api/etapasServiciosCotizaciones`,
          {
            servicio: response.data.doc.id,
            name: "Etapa 2",
          }
        );
      } catch (error) {
        console.error(
          `Error in POST request for object with id ${service.id}`,
          error
        );
      }
    }
  };

  const postAllPagos = async (idCotizacion) => {
    for (const pago of pagoList) {
      try {
        // Assuming you have a specific endpoint for your POST request
        const response = await axios.post(`${BACKEND}/api/pagosCotizaciones`, {
          cotizacion: idCotizacion,
          descripcion: pago.descripcion,
          percentage: pago?.percentage,
          precio: pago?.precio,
          pagado: false,
          active: true,
        });
      } catch (error) {
        console.error(
          `Error in POST request for object with id ${pago.id}`,
          error
        );
      }
    }
  };

  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      title={"Renovar cotización"}
    >
      <div className="  inline-flex mt-6 justify-end ">
        <div>
          <label
            htmlFor={"fechaCotizacionLimite"}
            class="block mb-2 text-sm font-medium text-gray-900 "
          >
            Fecha cotización límite
          </label>
          <Datepicker
            popoverDirection={"down"}
            toggleClassName="absolute bg-blue-300    rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
            inputClassName={
              "   rounded-md bg-gray-50  border border-gray-300  py-2  px-10 text-gray-700 "
            }
            inputId="fechaCotizacionLimite"
            containerClassName={"   relative"}
            useRange={false}
            asSingle={true}
            classNames={" z-[9999]"}
            placeholder={"Fecha de Inicio"}
            value={formValues.fechaCotizacionLimite}
            onChange={(e) =>
              setFormValues((prev) => ({ ...prev, fechaCotizacionLimite: e }))
            }
          />
        </div>
      </div>

      <div className="my-3">
        <label
          htmlFor={"numeroRenovacion"}
          class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          Número de renovación
        </label>
        <input
          type="text"
          id={"numeroRenovacion"}
          value={formValues.numeroRenovacion}
          onChange={(e) =>
            setFormValues((prev) => ({
              ...prev,
              numeroRenovacion: Number(e.target.value),
            }))
          }
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder={""}
          required
        />
      </div>

      <div className="my-6">
        <div
          htmlFor={"numeroRenovacion"}
          class="block  text-sm font-medium text-gray-900 dark:text-white"
        >
          Número de cotización
        </div>
        <p className=" text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 ">
          {data.numeroCotizacion}
        </p>
      </div>
      {data?.cliente && (
        <div className="my-6">
          <div
            htmlFor={"numeroRenovacion"}
            class="block  text-sm font-medium text-gray-900 dark:text-white"
          >
            Cliente
          </div>
          <p className=" text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 ">
            {data.cliente.nombreComercial}
          </p>
        </div>
      )}

      <div className=" my-12 flex justify-center ">
        <button
          type=" button"
          onClick={renewCot}
          className=" font-semibold flex justify-center items-center gap-3 max-w-sm w-full bg-blue-600 hover:bg-blue-700 text-white rounded-md p-2"
        >
          {loading ? (
            <FormLoader className={"w-10 h-6"} colour={"white"} />
          ) : (
            <>
              {" "}
              Renovar
              <MdAutorenew />
            </>
          )}
        </button>
      </div>
    </ModalInDrawer>
  );
};

export default RenovarCotiDialog;
